export default __webpack_public_path__ + "static/media/success-tick.7a1def9b.svg";